<template>
  <div class="login-password form">
    <div class="ipt-item">
      <customField
        v-model="form.account"
        :placeholder="$t('login.account_placeholder')"
        @input="handleInputAccount"
      >
        <template slot="next" v-if="form.account && form.account.length > 0">
          <div class="icon-box" @click="clearAccount"><Icon name="clear" color="#888" /></div>
        </template> 
      </customField>
    </div>
    <div class="ipt-item">
      <custom-field
        :placeholder="$t('login.password_placeholder')"
        type="password"
        :open-eye-function="true"
        v-model="form.password"
        ref="custom-field-password"
      >
        <template slot="clear" v-if="form.password && form.password.length > 0">
          <div class="icon-box clear-icon" @click="clearPassword"><Icon name="clear" color="#888" /></div>
        </template>
      </custom-field>
    </div>
    <div class="agreement-box">
      <Checkbox v-model="isCheckAgreement" >
        {{ $t("disclaimers.aggreen") }}
        <span class="link" @click.stop="toDisclaimers">{{
          $t("disclaimers.aggereen_title")
        }}</span>
      </Checkbox>
    </div>
    <div class="empty"></div>
    <div
      class="btn-submit mb0"
      :class="{ dis: submitDis }"
      @click="login"
    >
      {{ $t("common.confirm") }}
    </div>

    <!--  异常弹窗  -->
    <passwordErrorPrompt
      v-if="isShowLoginErrorPopup"
      :err-code="loginErrorData.errCode"
      :err-html="loginErrorData.data.err_msg.h5"
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    />
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import { Checkbox, Icon } from "vant";
import { getBrowser } from "@/utils/browser";
import { login } from "@/utils/hybirdMethods";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import { trimPlus } from "@/utils/utils.new";

export default {
  components: {
    customField,
    Checkbox,
    passwordErrorPrompt,
    Icon
  },
  props: {
    userInfo: {
      type: [Object, String],
      defaults: function(){
        return {}
      }
    }
  },
  watch: {
    userInfo: {
      handler(newVal){
        if(newVal.user_id){
          this.form.account = newVal.user_id;
        }
      },
      immediate: true
    }
  },
  computed: {
    submitDis(){
      return !(
        trimPlus(this.form.account) &&
        trimPlus(this.form.password) &&
        this.isCheckAgreement
      );
    }
  },
  data() {
    return {
      form: {
        account: "",
        password: "",
        login_type: "1"
      },
      isCheckAgreement: false,
      isShowLoginErrorPopup: false, // 是否显示弹窗
      loginErrorData: "" // 登录异常数据
    };
  },
  methods: {
    // 清除账号
    clearAccount() {
      this.form.account = "";
    },
    // 清除密码
    clearPassword() {
      this.form.password = "";
    },
    // 免责申明
    toDisclaimers() {
      this.$router.push({
        path: "/login-disclaimers"
      });
    },
    // 登录
    login() {
      this.isShowLoginErrorPopup = false;
      this.form.account = trimPlus(this.form.account);
      this.form.password = trimPlus(this.form.password);
      if (!this.isCheckAgreement || !this.form.account || !this.form.password) {
        return;
      }
      this.$apis.authV2LoginApi(this.form).then(res => {
        const { code } = res;
        // 有code 即异常，非异常 res直接为 data中的数据，request问题
        this.$setStorageApp("login_mode", 1);
        if (code) {
          if (code === 100173 || code === 100174) {
            this.isShowLoginErrorPopup = true;
            this.loginErrorData = res;
            return false;
          }
        } else {
          const { token, user_info } = res;
          this.$localstorage.set("userInfo", user_info);
          sessionStorage.setItem("token", token);
          // 登录成功
          if (getBrowser().isApp) {
            login(res);
          } else {
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect);
            } else if (this.$route.query.open == 1) {
              this.$router.push({
                path: "/open-account/home"
              });
            } else {
              this.$router.go(-1);
            }
          }
        }
      });
    },
    // 异常弹窗确认
    passwordErrorPromptConfirm() {
      this.isShowLoginErrorPopup = false;
      if (this.loginErrorData.code === 100173) {
        this.form.password = "";
        this.$refs["custom-field-password"].setInputFocus();
      }
    },
    handleInputAccount() {
      this.$emit("handleInputAccount", this.form.account);
    },
  }
};
</script>

<style scoped lang="less">
@import "./form.comon.less";
.icon-box{
  padding: 0 20px;
  display: flex;
  align-items: center;
  height: 100%;
  &.clear-icon {
    position: absolute;
    right: 70px;
    top: 0;
    padding: 0;
    width: 50px;
    justify-content: center;
  }
}
</style>
